var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorPageImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1124,
    height: 204,
    viewBox: "0 0 1124 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1121.5 86.5C1121.5 86.5 989.171 30.04 931.437 42.4579C882.133 53.0624 868.365 81.4376 816.224 86.6843C775.588 90.7733 743.246 55.6084 703.432 62.5362C642.809 73.0848 626.897 123.477 626.897 123.477",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1122 60C1122 60 989.645 8.03396 931.911 20.4518C882.608 31.0564 868.84 59.4316 816.699 64.6782C776.063 68.7672 742.098 39.6477 702.284 46.5755C627.008 59.6737 625.239 125.872 625.239 125.872",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.5 112.5C1121.5 112.5 1011.88 53.7185 933 68C883.36 76.9877 871.248 102.687 819.09 107.935C778.442 112.026 742.368 68.6804 702.541 75.6109C641.899 86.1635 624.92 127.217 624.92 127.217",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.5 134.5C1121.5 134.5 1014.82 82.9859 952.5 91C903.518 97.2985 884.001 131.638 818.501 135C769.538 137.513 742.289 91.8799 699.502 95.0001C665.362 97.4898 614.002 139.5 614.002 139.5",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1122 158.5C1122 158.5 1022.29 106.562 943.414 120.844C893.774 129.832 869.136 160.889 818 159.5C766.486 158.101 748.295 110.811 699.5 113.5C663.812 115.467 626 147.5 626 147.5",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99982 112.5C1.99982 112.5 133.839 61.04 191.573 73.4579C240.876 84.0624 254.645 112.438 306.786 117.684C347.422 121.773 379.764 86.6084 419.578 93.5362C480.201 104.085 496.113 154.477 496.113 154.477",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49824 84.9999C2.49824 84.9999 133.363 39.0339 191.097 51.4518C240.4 62.0563 254.169 90.4315 306.31 95.6782C346.946 99.7671 380.911 70.6476 420.725 77.5754C496.001 90.6737 497.77 156.872 497.77 156.872",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49727 138.5C1.49727 138.5 98.6214 81.7185 177.5 96C227.14 104.988 251.763 133.687 303.921 138.935C344.57 143.026 380.643 99.6803 420.47 106.611C481.112 117.163 498.091 158.217 498.091 158.217",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 168.5C2 168.5 96.1214 107.572 175 121.853C224.64 130.841 253.563 160.485 305.721 165.734C346.37 169.824 379.919 118.733 422.706 121.853C456.846 124.343 496.767 159.02 496.767 159.02",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 198C2.5 198 101.249 140.562 180.127 154.844C229.768 163.832 250.88 194.894 303.037 200.142C343.686 204.233 371.941 147.871 414.44 143.146C464.749 137.553 498.34 166.326 498.34 166.326",
    stroke: "#4866E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 124,
    r: 80,
    fill: "#F4F4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 590.572,
    cy: 93.5239,
    r: 2.35714,
    fill: "#141140",
    stroke: "#141140"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 546.763,
    cy: 107.81,
    r: 2.35714,
    fill: "#141140",
    stroke: "#141140"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M538.211 159.238V106.639M538.211 106.639C547.717 122.095 555.336 106.639 555.336 106.639C555.336 106.639 551.72 102.095 547.241 102.095C543.291 102.095 540.405 104.193 538.211 106.639Z",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M582.138 145.183V92.5846M582.138 92.5846C591.529 107.81 598.672 92.5846 598.672 92.5846C598.672 92.5846 595.533 87.8097 591.053 87.8097C587.103 87.8097 584.332 90.1382 582.138 92.5846Z",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M582.121 145.182C582.121 145.182 573.336 133.391 559.671 137.764C546.005 142.137 538.195 159.238 538.195 159.238",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M743.816 81.6808V101.042L724.455 105.883V84.9077",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.128 77.6303C749.497 76.7684 751.882 77.3495 752.457 78.9282C753.031 80.5068 751.577 82.4853 749.209 83.3472C746.841 84.2091 744.456 83.628 743.881 82.0493C743.307 80.4707 744.76 78.4922 747.128 77.6303Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M727.765 80.8572C730.133 79.9953 732.519 80.5764 733.093 82.1551C733.668 83.7338 732.214 85.7123 729.846 86.5741C727.478 87.436 725.093 86.855 724.518 85.2763C723.943 83.6976 725.397 81.7191 727.765 80.8572Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.816 148.681V168.042L266.455 172.883V151.908",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.128 144.63C291.497 143.768 293.882 144.349 294.457 145.928C295.031 147.507 293.577 149.485 291.209 150.347C288.841 151.209 286.456 150.628 285.881 149.049C285.307 147.471 286.76 145.492 289.128 144.63Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.765 147.857C272.133 146.995 274.519 147.576 275.093 149.155C275.668 150.734 274.214 152.712 271.846 153.574C269.478 154.436 267.093 153.855 266.518 152.276C265.943 150.698 267.397 148.719 269.765 147.857Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M957.57 25.6689V6.73377L976.505 2V22.513",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954.333 29.6295C952.018 30.4724 949.685 29.9041 949.123 28.3602C948.561 26.8163 949.983 24.8814 952.298 24.0385C954.614 23.1956 956.947 23.7639 957.509 25.3078C958.071 26.8517 956.649 28.7866 954.333 29.6295Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M973.267 26.4733C970.951 27.3162 968.618 26.7479 968.056 25.204C967.494 23.6601 968.916 21.7252 971.232 20.8823C973.548 20.0394 975.881 20.6076 976.443 22.1516C977.005 23.6955 975.583 25.6304 973.267 26.4733Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.57 64.6689V45.7338L222.505 41V61.513",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.333 68.6295C198.018 69.4724 195.685 68.9041 195.123 67.3602C194.561 65.8163 195.983 63.8814 198.298 63.0385C200.614 62.1956 202.947 62.7639 203.509 64.3078C204.071 65.8517 202.649 67.7866 200.333 68.6295Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.267 65.4733C216.951 66.3162 214.618 65.7479 214.056 64.204C213.494 62.6601 214.916 60.7252 217.232 59.8823C219.548 59.0394 221.881 59.6076 222.443 61.1516C223.005 62.6955 221.583 64.6304 219.267 65.4733Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M862.633 105C862.633 109.492 871.971 108.953 871.971 113.894",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M862.633 105V123.256",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.747 126.781C857.686 127.531 855.609 127.025 855.109 125.651C854.609 124.277 855.874 122.555 857.936 121.805C859.997 121.055 862.073 121.56 862.573 122.934C863.073 124.308 861.808 126.03 859.747 126.781Z",
    stroke: "#141140",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M385.633 100C385.633 104.466 394.971 103.93 394.971 108.843",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M385.633 100V118.151",
    stroke: "#141140",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.747 121.655C380.686 122.401 378.609 121.898 378.109 120.532C377.609 119.166 378.874 117.454 380.936 116.708C382.997 115.962 385.073 116.465 385.573 117.831C386.073 119.197 384.808 120.909 382.747 121.655Z",
    stroke: "#141140",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageImg);
export default __webpack_public_path__ + "static/media/errorPageImg.528cb55714e84e615a29418640dce5de.svg";
export { ForwardRef as ReactComponent };